import { render } from "./Knowledge.vue?vue&type=template&id=7aeca188"
import script from "./Knowledge.vue?vue&type=script&lang=js"
export * from "./Knowledge.vue?vue&type=script&lang=js"

import "./Knowledge.vue?vue&type=style&index=0&id=7aeca188&lang=scss"

import exportComponent from "C:\\Users\\Riccardo\\Desktop\\vue-app\\portfolio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__